import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalHeaderComponent } from '@cf/shared/dialog';
import { TimezoneNamePipe } from '@cf/shared/forms/timezone-select';
import { ButtonComponent } from '@cf/shared/ui/button';
import { TextComponent } from '@cf/shared/ui/typography';
import { AccountService } from '@cf/temp/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'cf-timezone-confirmation',
  templateUrl: './timezone-confirmation-modal.component.html',
  styleUrl: './timezone-confirmation-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ModalHeaderComponent,
    TextComponent,
    ButtonComponent,
    TimezoneNamePipe,
    NgxTolgeeModule,
  ],
})
export class TimezoneConfirmationModalComponent {
  public readonly activeModal = inject(NgbActiveModal);
  public readonly accountService = inject(AccountService);
}
